"use client";

import { useState } from "react";
import { idelioService, IdelioPayload } from "../services/idelioService";

export function useIdelioCall() {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState<boolean | null>(null);
  const [error, setError] = useState<Error | null>(null);

  async function sendIdelioCall(payload: IdelioPayload) {
    setLoading(true);
    setError(null);
    setSuccess(null);

    try {
      const result = await idelioService.sendCall(payload);
      setSuccess(true);
      return result;
    } catch (err) {
      setError(err as Error);
      setSuccess(false);
      console.error("Erreur appel Idelio :", err);
    } finally {
      setLoading(false);
    }
  }

  return { sendIdelioCall, loading, success, error };
}
